import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, errorMessage } from "@/lib/api";

export const MessageEditDialog = ({ message, onClose, onSaved }) => {
  const [body, setBody] = useState("");
  const [subject, setSubject] = useState("");
  const [busy, setBusy] = useState(false);
  const email = message?.channel === "email";

  useEffect(() => {
    if (message) { setBody(message.body || ""); setSubject(message.subject || ""); }
  }, [message]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put(`/messages/${message.id}`, { body, ...(email ? { subject } : {}) });
      toast.success("Mensagem atualizada. Ela será usada no próximo envio.");
      onSaved();
      onClose();
    } catch (err) { toast.error(errorMessage(err)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!message} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="border-slate-700 bg-slate-900 sm:max-w-lg" data-testid="message-edit-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl font-bold">Editar mensagem</DialogTitle>
          <DialogDescription>{message?.client_name} · {message?.service_name} · {email ? "E-mail" : "WhatsApp"}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          {email && (
            <div className="space-y-1.5">
              <Label htmlFor="me_subject">Assunto</Label>
              <Input id="me_subject" value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Usa o assunto padrão se ficar vazio" className="h-10 bg-slate-950" data-testid="message-edit-subject" />
            </div>
          )}
          <div className="space-y-1.5">
            <Label htmlFor="me_body">Texto</Label>
            <Textarea id="me_body" rows={6} required value={body} onChange={(e) => setBody(e.target.value)} className="bg-slate-950" data-testid="message-edit-body" />
          </div>
          <DialogFooter className="gap-2">
            <Button type="button" variant="ghost" onClick={onClose} data-testid="message-edit-cancel">Cancelar</Button>
            <Button type="submit" disabled={busy} className="rounded-full font-semibold" data-testid="message-edit-save">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Salvar</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
